
import React ,{Component} from 'react'; 
import { Navigate  } from 'react-router-dom';
import axios from 'axios'; 
import Table from '@mui/material/Table';
import Serverurl from './Apiurl';
import Button from '@mui/material/Button';
import PropTypes from 'prop-types';
import TableRow from '@mui/material/TableRow'; 
import { makeStyles } from '@mui/styles'; 
import Paper from '@mui/material/Paper';  
import TableSortLabel from '@mui/material/TableSortLabel';
import TableBody from '@mui/material/TableBody'; 
import TableCell from '@mui/material/TableCell';  
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';  
import TablePagination from '@mui/material/TablePagination'; 
import DeleteIcon from '@mui/icons-material/Delete';
import TextField from '@mui/material/TextField';
import EditIcon from '@mui/icons-material/Edit';
import AddIcon from '@mui/icons-material/Add';
import Collapse from '@mui/material/Collapse';
import CloseIcon from '@mui/icons-material/Close';
import Alert from '@mui/material/Alert';
import IconButton from '@mui/material/IconButton';
import DialogContent from '@mui/material/DialogContent';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import Select from '@mui/material/Select';
import FormControl from '@mui/material/FormControl';
import SearchIcon from '@mui/icons-material/Search';
import ReactToPrint from 'react-to-print';




import dayjs from 'dayjs';
import { DemoContainer, DemoItem } from '@mui/x-date-pickers/internals/demo';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import Moment from 'react-moment';
import moment from 'moment';


import ReactHTMLTableToExcel from 'react-html-table-to-excel';
const headCells = [

	

  { id: 'st_name', numeric: false, label: 'Yoga Trainer ' },
  { id: 'sb_title', numeric: false, label: 'Duration' },
 
 
 { id: 'sl_checkindate', numeric: false, label: 'Check In Date' },  
  { id: 'sl_checkoutdate', numeric: false, label: 'Check Out Date' },    
  { id: 'total_time', numeric: false, label: 'Total Hour' },    

 

  
    
 
 
 ]

function stableSort(array, cmp) {
	  const stabilizedThis = array.map((el, index) => [el, index]);
	  stabilizedThis.sort((a, b) => {
		const order = cmp(a[0], b[0]);
		if (order !== 0) return order;
		return a[1] - b[1];
	  });
	  return stabilizedThis.map(el => el[0]);
}
function desc(a, b, orderBy) {
	  if (b[orderBy] < a[orderBy]) {
		return -1;
	  }
	  if (b[orderBy] > a[orderBy]) {
		return 1;
	  }
	  return 0;
}
function getSorting(order, orderBy) {
	return order === 'desc' ? (a, b) => desc(a, b, orderBy) : (a, b) => -desc(a, b, orderBy);
}
 
function EnhancedTableHead(props) {
  const { classes,  order, orderBy,  rowCount, onRequestSort } = props;
  const createSortHandler = property => event => {
    onRequestSort(event, property);
  };

  return (
    <TableHead>
      <TableRow>
        
        {headCells.map(headCell => (
          <TableCell
            key={headCell.id}
            align={headCell.numeric ? 'right' : 'left'}
            padding={headCell.disablePadding ? 'none' : 'default'}
            sortDirection={orderBy === headCell.id ? order : false}
          >
            <TableSortLabel
              active={orderBy === headCell.id}
              direction={orderBy === headCell.id ? order : 'asc'}
              onClick={createSortHandler(headCell.id)}
            >
              {headCell.label}
              {orderBy === headCell.id ? (
                <span className={useStyles.visuallyHidden}>
                  {order === 'desc' ? ' ' : ' '}
                </span>
              ) : null}
            </TableSortLabel>
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  );
}

EnhancedTableHead.propTypes = {
  classes: PropTypes.object.isRequired,
 
  onRequestSort: PropTypes.func.isRequired,
 
  order: PropTypes.oneOf(['asc', 'desc']).isRequired,
  orderBy: PropTypes.string.isRequired,
  rowCount: PropTypes.number.isRequired,
};
const useToolbarStyles = makeStyles(theme => ({
  root: {
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(1),
  },
  
  
  title: {
    flex: '1 1 100%',
  },
}));

const EnhancedTableToolbar = props => {
  const classes = useToolbarStyles();
  const { numSelected } = props;

  };

EnhancedTableToolbar.propTypes = {
  numSelected: PropTypes.number.isRequired,
};


const useStyles = makeStyles({  
  root: {  
    width: '100%',  
  },  
  container: {  
    maxHeight: 440,  
  }, 
 icon: {
   verticalalign:'middle',
  },
  table: {
    minWidth: 750,
  },
  visuallyHidden: {
    border: 0,
    clip: 'rect(0 0 0 0)',
    height: 1,
    margin: -1,
    overflow: 'hidden',
    padding: 0,
    position: 'absolute',
    top: 20,
    width: 1,
  }, 


});




export default class StaffCheckingReport extends Component {
	
    constructor(props) {
    super(props);
    
   var strdob=new Date();
	 var month="";
	
	 if((strdob.getMonth() + 1)<10)
	 {
		month="0"+ (strdob.getMonth() + 1)		 
	 }else{month=(strdob.getMonth() + 1)}
     this.state = {
		 
		 sl_checkindate1:strdob.getFullYear() + '-' + month + '-' +strdob.getDate(),sl_checkoutdate1:strdob.getFullYear() + '-' + month + '-' +strdob.getDate(),sl_checkindate:Date.now(),sl_checkoutdate:Date.now(),
		 name:'',sl_st_id:'',sb_id:'',subscriptionarray:[],staffarray:[],cu_name:'',st_name:'',sl_id:'',sl_latitude:'',sl_longitude:'',sl_checkindate:'',sl_checkoutdate:'',sb_title:'',cs_date:'',
	 
	 
		 ExportData:[],
		 redirect: false,editredirect: false,no_id:'',no_date:'',fb_staff:0,no_remiderdate:'',type:'',exportdata:[],
     locationdata:[],page:0,prevpage:0,totaldata:0,rowsPerPage:10,rowsPaging:[],rolelabel:'Select Yoga Trainer',staff:'',staffarray:[],subscribeData:[],subid:'',
	 
	  order:'desc' ,orderBy:'',
	          
      }
	  this.updateDonenewParent = this.updateDonenewParent;
	}
	  



	

handleChangePage = (event, newPage) => {  

    let pageval = localStorage.getItem("page");
    this.setState({  
      page: newPage,
      rowsPerPage:this.state.rowsPerPage
    },()=>{ this.apicall(this.state.page,this.state.rowsPerPage);  });
   
 
    
  }; 
  	 myChangeHandler = (event) => {
	
	  const re = /^[0-9\b]+$/;
  let nam = event.target.name;
  let val = event.target.value;  
 

  this.setState({[nam]: val});
  
}

    handleChangeRowsPerPage = event => {  
  
    let pageval = event.target.value;
  

   
    this.setState({  
      page: 0,
      rowsPerPage:parseInt(pageval),
	  prevpage:-1
    },()=>{ this.apicall(this.state.page,this.state.rowsPerPage); }); 
	
	
  };  
componentWillMount  () {
	

	
	document.title = "AthaYog Living - Location";
	
	if(localStorage.getItem("AYLuserid")==null)
		  {

		   this.setState({
            redirect: true,
			pagename:'/Default'
          })
		  }

		this.onloadStaffbind();
		//	this.onloadSubscriptionbind();
		this.apiExportcall();
	  localStorage.setItem("page",this.state.rowsPerPage)
  this.apicall(this.state.page,this.state.rowsPerPage);
  
}

apicall(page,rowsPerPage){
	
 axios.get(Serverurl+'ajaxstafflolcationtracking.php?action=report&StartIndex='+page+'&PageSize='+rowsPerPage+'&sl_st_id='+this.state.name+'&sl_checkindate='+this.state.sl_checkindate1+'&sl_checkoutdate='+this.state.sl_checkoutdate1)

  .then(resp => {  
		
    if(resp.data.length>0){
		
			this.setState({  
			  locationdata:resp.data,  
			   totaldata:parseInt(resp.data[0].count),
			   

		    });
		
		
			
	 
     }
	 else{
		   this.setState({locationdata:[],totaldata:0});
	 }
 
    });
}

apiExportcall(){
	
 axios.get(Serverurl+'ajaxstafflolcationtracking.php?action=report')

  .then(resp => {  
		
    if(resp.data.length>0){
		
			this.setState({  
			  ExportData:resp.data,  
			   
			   

		    });
		
		
	 
     }
	 else{
		   this.setState({ExportData:[]});
	 }
 
    });
}










 
  
    handleRequestSort = (event, property) => {
  const isAsc = this.state.orderBy === property && this.state.order === 'asc';
  

  this.setState({   orderBy: property,
    order:isAsc  ? 'desc' : 'asc'
   
  });
};
  
 

handleClickSearch=()=>{   
   
  this.apicall(this.state.page,this.state.rowsPerPage); 
	
} 






onloadStaffbind(){

    axios.get(Serverurl+'ajaxstaff.php?action=getall&st_role=3&st_id='+this.state.name)
	
    
      .then((response) => {    
     
      this.setState({ staffarray: response.data,  },()=>{
		  
		  let roleFromApi = this.state.staffarray.map(st => {
                            
          return {value:st.st_id, display:st.st_name}
        });
      
        this.setState({
          staffarray: [{value: '', display: 'All'}].concat(roleFromApi)
        });
		  
		  
	  });
	  
	
      })   
    
    
} 

  
 handfrChange = (date) => {
	 var month="";
	
	 if((date.getMonth() + 1)<10)
	 {
		month="0"+ (date.getMonth() + 1)		 
	 }else{month=(date.getMonth() + 1)}
     this.setState({sl_checkindate:date,
sl_checkindate1:date.getFullYear() + '-' + month + '-' +date.getDate()
	 })
	
	
  }  
    
handtoChange = (date) => {
	  var month="";
	 
	 if((date.getMonth() + 1)<10)
	 {
		month="0"+ (date.getMonth() + 1)		 
	 }else{month=(date.getMonth() + 1)} 
	 

	 
     this.setState({ sl_checkoutdate:date,
sl_checkoutdate1:date.getFullYear() + '-' + month + '-' +date.getDate()
	 })
	
	
  }


render() {
	
	
	if (this.state.logredirect === true) {
      return <Navigate to={this.state.pagename} />
    }
return(
 

 <React.Fragment>
 
  <div className="mainheading"><h1>Yoga Trainer Attendance Report</h1></div>

<div className="clear"></div>

	
	

 <div className="searchmaster">
 <ul>
  
 <li><p>Name</p>
 <p><TextField name="cu_name" 
	   onChange={this.myChangeHandler} 
	   fullWidth 		 	 inputProps={{tabIndex: "2",maxLength:150}} className="txtbox"
	   value={this.state.cu_name}
                          /></p>
 
 </li>
 
 
 
 <li><p>Yoga Trainer</p>
 
 <p><FormControl  className="stadrp">
         
        <Select
         native  fullWidth
		 className="txtbox"
		  inputProps={{tabIndex: "2"}} 
		 variant="outlined"
            margin="normal"
		  defaultValue={{ label: this.state.rolelabel, value: this.state.name}}
          onChange={this.myChangeHandler}
          id="name"
		   value={this.state.name}
		  name="name"
		
		
        >
		{this.state.staffarray.map(staff => (
            <option  
            
              value={staff.value}
            >
              {staff.display}
            </option  >
          ))}
		
        </Select></FormControl>
		
				</p></li>
				
								<li>
<p>Check In Date</p>
 <p>
 <LocalizationProvider dateAdapter={AdapterDayjs}>
      <DemoContainer components={['DatePicker']}>
<DatePicker
value= {dayjs(this.state. sl_checkindate) }
className="txtbox" 
 inputProps={{tabIndex: "1"}}
    onChange={this.handnodateChanges} format="DD/MM/YYYY"
/>  </DemoContainer>
    </LocalizationProvider>
		
		</p></li>
<li>
	<p>Checkout Date</p>
	  <p>
	   <LocalizationProvider dateAdapter={AdapterDayjs}>
      <DemoContainer components={['DatePicker']}>
<DatePicker 
value= {dayjs(this.state.sl_checkoutdate) }
className="txtbox" 
 inputProps={{tabIndex: "2"}}
    onChange={this.handtoChanges} format="DD/MM/YYYY"
/>  </DemoContainer>
    </LocalizationProvider>
		
	
		</p></li>		
		
				
				
		
					<li><p >
		<Button variant="contained" onClick={this.handleClickSearch} className="frmSecondarybtn" endIcon={<SearchIcon />}>
        Search
      </Button> &nbsp;
		<ReactHTMLTableToExcel
							id="test-table-xls-button"
							className="frmSecondarybtn"
							table="Staffcheckinreport"
							filename="Yoga Trainer Attendance Report"
							sheet="Yoga Trainer Attendance Report"
							buttonText="EXPORT"/>
							
			
				</p>		
		</li>
		
		
		</ul>
		
</div>	
	<div ref={el => (this.componentRef = el)}  >
			
<Paper className={useStyles.root}>

  <TableContainer className={useStyles.container}>  
                <Table stickyHeader aria-label="sticky table">  
<TableHead> 
<TableRow>
                                              
                       
						
                      </TableRow></TableHead>
					  
					   <EnhancedTableHead           
              order={this.state.order}
              orderBy={this.state.orderBy}
              
              onRequestSort={this.handleRequestSort}
              rowCount={this.state.locationdata.length}
            />
                      <TableBody>
                     {stableSort(this.state.locationdata, 
			getSorting(this.state.order,
			this.state.orderBy)).map((item,index) => {  
			
           return (
 <React.Fragment>
 <TableRow key={index} >




<TableCell style={{"width":"20px"}}>{item.st_name}</TableCell>
<TableCell style={{"width":"20px"}}>{item.sb_title}</TableCell>
<TableCell style={{"width":"20px"}}>{item.sl_checkindate}</TableCell>
<TableCell style={{"width":"20px"}}>{item.sl_checkoutdate}</TableCell>
<TableCell style={{"width":"20px"}}>{item.total_time}</TableCell>


 </TableRow>

 </React.Fragment>	
);
					})}
					
					{this.state.totaldata===0 &&(
					
					<TableRow key={0} >
<TableCell align="center" colspan="4">No Records</TableCell>
					</TableRow>
					) }
					
                      </TableBody>


</Table>
  </TableContainer> 
  <TablePagination  
        rowsPerPageOptions={[50,100,150,200,250,300]}
        component="div"  
        count={this.state.totaldata}  
        rowsPerPage={this.state.rowsPerPage}  
        page={this.state.page}  
        onPageChange={this.handleChangePage}  
        onRowsPerPageChange={this.handleChangeRowsPerPage}    
      /> 
  </Paper>
    

</div>





<div style={{"display":"none"}}>
			
<Paper className={useStyles.root}>

  <TableContainer className={useStyles.container}>  
                <Table stickyHeader aria-label="sticky table" id="Staffcheckinreport">  
<TableHead> 
<TableRow>
                                              
                       
						
                      </TableRow></TableHead>
					  
					   <EnhancedTableHead           
              order={this.state.order}
              orderBy={this.state.orderBy}
              
              onRequestSort={this.handleRequestSort}
              rowCount={this.state.ExportData.length}
            />
                      <TableBody>
                     {stableSort(this.state.ExportData, 
			getSorting(this.state.order,
			this.state.orderBy)).map((item,index) => {  
			
           return (
 <React.Fragment>
 <TableRow key={index} >


<TableCell style={{"width":"20px"}}>{item.st_name}</TableCell>
<TableCell style={{"width":"20px"}}>{item.sb_title}</TableCell>
<TableCell style={{"width":"20px"}}>{item.sl_checkindate}</TableCell>
<TableCell style={{"width":"20px"}}>{item.sl_checkoutdate}</TableCell>

<TableCell style={{"width":"20px"}}>{item.total_time}</TableCell>


 </TableRow>

 </React.Fragment>	
);
					})}
					
					{this.state.totaldata===0 &&(
					
					<TableRow key={0} >
<TableCell align="center" colspan="4">No Records</TableCell>
					</TableRow>
					) }
					
                      </TableBody>


</Table>
  </TableContainer> 
 
  </Paper>
 
</div>


 </React.Fragment>
 



);


		}
	
}

